import { render, staticRenderFns } from "./distributionKanban.vue?vue&type=template&id=67dd04ac"
import script from "./distributionKanban.vue?vue&type=script&lang=js"
export * from "./distributionKanban.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports